module.exports = __webpack_public_path__ + "static/sigmacomputing-d757b8ba9f9aeaf3a47767109101a8a8.png";